﻿import { useAuthStore } from './common/auth/authstore';
import { Dialog } from 'quasar'

class Rest {
    async Get(url, config) {
        return axios.get(url, await this.getConfig(config))
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                this.processError(error);
                return Promise.reject(error.response);
            });
    }

    async Post(url, data, config) {
        return axios.post(url, data, await this.getConfig(config))
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                this.processError(error);
                return Promise.reject(error.response);
            });
    }

    async getConfig(config) {
        const store = useAuthStore();

        if (!config?.annonymous && !store.IsAuthValid()) {
            await store.Validate();
        }

        if (!store.Auth) {
            return config || {};
        }

        var extended = Object.assign({
            headers: {
                'Authorization': 'Bearer ' + store.Auth.token,
                'Content-Type': 'application/json'
            }
        },
            config);

        return extended;
    }

    processError(error) {
        const store = useAuthStore();
        if (error.response.status == 401) {
            if (store.Auth) {
                store.Auth = null;
            }
        }
        if (error.response.status == 403) {
            Dialog.create({
                title: 'Unauthorized',
                message: 'You are not authorize to take this action'
            });
        }
        if (error.response.status == 500) {
            Dialog.create({
                title: 'Error',
                message: `<p>${error.response.data.Message}</p><p>Refresh the page or try again.</p>`,
                html: true
            });
        }
    }
}

export default new Rest();